import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';
import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';
import CheckboxListComponent from '72cms-ui/components/form-elements/CheckboxListComponent';
import PageDetailsFormLayout from '72cms-ui/components/form-elements/PageDetailsFormLayout';
import PageBuilderComponent from '72cms-ui/components/helpers/PageBuilderComponent';
import DropdownActionsButtonComponent from '72cms-ui/components/helpers/DropdownActionsButtonComponent';

export default {
    sections: ['details', 'image', 'meta data'],
    groups: {

    },
    toolbar: [
        'add', 'edit', 'separator', 'active', 'preview', 'delete',
    ],
    fields: {
        name: {
            section: 'details',
            position: 0,
            description: '',
        },
        
        location: {
            section: 'details',
            position: 1,
            description: '',
        },

        intro: {
            section: 'details',
            position: 2,
            component: ExpandableTextComponent,
        },

        content: {
            section: 'details',
            position: 3,
            editorClass: 'copy',
        },

        image: {
            section: 'image',
            position: 0,
            description: 'Please resize images to 680px x 680px prior to uploading. The filesize of your image should not exceed <strong>10MB</strong>.',
        },

        title: {
            section: 'meta data',
            position: 1,
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = entry.newValue;
                }
            }
        },

        name_id: {
            label: 'Page URL',
            section: 'meta data',
            position: 2,
            description: 'This field will be populated based on page name if left blank',
            prefix: '/case/',
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = V.slugify(entry.newValue);
                }
            }
        },

        meta_description: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },

        meta_keywords: {
            section: 'meta data',
            position: 4,
            component: ExpandableTextComponent,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.case_study.js